import React, { Component } from 'react';

import { Input, ErrorMessage, SaveButton, ButtonWrapper, ErrorWrapper } from './styled/UserNickNameStyled';

interface NickNameProps {
    pending: boolean;
    errorCode?: number | string | null;
    localization: { getText: (key: string) => string };
    onSave: (value: string) => void;
    value: string;
}

interface NickNameState {
    value: string;
}

class NickName extends Component<NickNameProps, NickNameState> {
    static defaultProps = {
        errorCode: null
    };

    state = {
        value: this.props.value
    };

    onChange(value: string) {
        this.setState({ value });
    }

    saveButtonClicked() {
        const { pending, onSave } = this.props;

        if (!pending) {
            onSave(this.state.value);
        }
    }

    captureEnter(event: React.KeyboardEvent<HTMLInputElement>) {
        if (event.key === 'Enter') {
            (event.target as HTMLInputElement).blur();
        }
    }

    render() {
        const { pending, errorCode, localization } = this.props;

        return (
            <div>
                <Input
                    type="text"
                    value={this.state.value}
                    disabled={pending}
                    onChange={({ target }) => this.onChange(target.value)}
                    onKeyUp={this.captureEnter}
                />
                <ErrorWrapper>
                    {errorCode && <ErrorMessage>{localization.getText(`settings.error.${errorCode}`)}</ErrorMessage>}
                </ErrorWrapper>
                <ButtonWrapper>
                    <SaveButton onClick={() => this.saveButtonClicked()}>{localization.getText('settings.nickname.button')}</SaveButton>
                </ButtonWrapper>
            </div>
        );
    }
}

export default NickName;
